import type { KeyPortRequestMessage } from '../../types/KeyPortRequestMessage';
import { useToasts } from '../cdl/Toast/useToasts';
import { translate } from '../common/helpers/translate.helper';
import { LoadingIndicator } from '../common/LoadingIndicator/LoadingIndicator';

import { KeyPortForm } from './KeyPortForm';
import { useKeyPortDetails } from './useKeyPortDetails';
import { useKeyPortEdit } from './useKeyPortEdit';

interface EditKeyPortFormProps {
    keyPortId: string;
    onSuccess: () => void;
}

export const EditKeyPortForm = ({ keyPortId, onSuccess }: EditKeyPortFormProps) => {
    const { addToast, addErrorToast } = useToasts();
    const { data, isPending } = useKeyPortDetails(keyPortId);
    const { mutateAsync: updateKeyPort, error } = useKeyPortEdit();

    const handleSubmit = async ({ data: keyPort }: { data: KeyPortRequestMessage }) => {
        try {
            await updateKeyPort(
                { keyPort, keyPortId },
                {
                    onSuccess: () => {
                        onSuccess();
                        addToast(translate('keyPorts.toast.updateKeyPort.success'));
                    },
                    onError: (mutationError) => {
                        if (mutationError.response?.status !== 400) {
                            addErrorToast(translate('keyPorts.toast.updateKeyPort.error'));
                        }
                    },
                }
            );
        } catch {
            return;
        }
    };

    if (isPending || !data) {
        return <LoadingIndicator variant="full-height" />;
    }

    return <KeyPortForm onSubmit={handleSubmit} errors={error?.response?.data?.errors} data={data} update />;
};
